import React from 'react'
import { connect } from 'react-redux'
import { AppState, OrderValue } from '../reducers'
import { Filters, Product, matchesFilters } from '../services/assortment.service'
import { sendParentSubmitKreator, getParentOrigin } from '../parentCommunication'

function handleClick(config, filters: Filters, order: {[key: number]: OrderValue[]}, products: Product[]) {
    let orderToExport = []
    for (const id of Object.keys(order)) {
        if (matchesFilters(products[id], filters)) {
            orderToExport.push({
                SymKar: products[id].symKar,
                count: order[id]
            });
        }
    }
    if (config.newOrderApplication) {
        let submitOrder;
        if (Object.keys(order).length === 0) {
            submitOrder = { 
                resetGutteringsCart: true, 
                filters: filters
            }
        } else {
            submitOrder = { 
                resetGutteringsCart: false, 
                filters: filters,
                order: orderToExport  
            }
        }
        sendParentSubmitKreator(submitOrder);
    } else {
        (window as any).submitKreator(JSON.stringify(orderToExport))
    }

    if (getParentOrigin()) {
        const btnMessage = document.getElementsByClassName("kr-ExportBtnNotification")[0];

        btnMessage.className = "kr-ExportBtnNotification show";
        setTimeout(() => {
            btnMessage.className = "kr-ExportBtnNotification";
        }, 4500);
    }
}

const ExportBtn = ({ config, order, filters, products }: ReturnType<typeof mapStateToProps>) => {
    return <div onClick={() => { handleClick(config, filters, order, products) }} className="kr-ExportBtn">Dodaj do koszyka</div>
}

const mapStateToProps = (state: AppState) => ({
    config: state.config,
    order: state.order,
    filters: state.filters,
    products: state.assortment.products
})

export default connect(mapStateToProps)(ExportBtn)
